
/*
 * triggerRATPageLoadEvent(siteSection, pageName)
 *
 * Triggers a page load event for the RAT (Rakuten Analytics Tracking) system.
 *
 * RAT code is loaded in the index.html template. It consists of a set of hidden input elements
 * that define some data to be sent, and loads the RAT JS file.
 *
 * On page load, the main page component should call this with appropriate section and page name
 * parameters on render.
 *
 */
export function triggerRATPageLoadEvent(siteSection, pageName, externalShopId) {
    let $siteSectionInput = document.getElementById('ratSiteSection');
    $siteSectionInput.value = siteSection;

    let $pageNameInput = document.getElementById('ratPageName');
    $pageNameInput.value = pageName;

    let $shopIdInput = document.getElementById('ratShopId');
    $shopIdInput.value = externalShopId;

    let event;
    if (typeof(window.Event) === 'function') {
        event = new Event('SINGLE_PAGE_APPLICATION_LOAD');
        document.dispatchEvent(event);
    } else {
        try {
            event = document.createEvent('Event');
            event.initEvent('SINGLE_PAGE_APPLICATION_LOAD', true, true);
            document.dispatchEvent(event);
        } catch (e) { /* intentional */ }
    }
}
